import * as React from 'react';
import { useIsAdminOnBuyOrderEditForm } from '../../../../utils/buy-order/use-is-admin-on-buy-order-edit-form';
import { SubmitButtonProps } from '../submit-button';
import { ButtonLoading } from '../../../form/components/button-loading/button-loading';

export function BuyProcessFormNextButton(props: SubmitButtonProps) {
  const isAdminOnForm = useIsAdminOnBuyOrderEditForm();

  return (
    <ButtonLoading
      variant={isAdminOnForm ? 'outlined' : 'contained'}
      color={isAdminOnForm ? 'default' : 'primary'}
      size="medium"
      type={isAdminOnForm ? 'button' : 'submit'}
      onClick={(event) => {
        if (isAdminOnForm && props.onClick) {
          props.onClick(event);
        }
      }}
      {...props}
    >
      {props.children}
    </ButtonLoading>
  );
}
